import { PopularProductsBuilder, SimilarProductsProductBuilder, ProductsViewedAfterViewingProductBuilder, RecentlyViewedProductsBuilder, Recommender } from "@relewise/client";
import fillProduct from "./fillProduct";
import { getUser } from "./utils";

const RELEWISE_DATASET_ID = relewiseData.relewise_dataset_id;
const RELEWISE_API_KEY = relewiseData.relewise_api_key;
const RELEWISE_SERVER_URL = relewiseData.relewise_server_url;
let recommender = false;

if (RELEWISE_API_KEY && RELEWISE_DATASET_ID && RELEWISE_SERVER_URL) {
  recommender = new Recommender(RELEWISE_DATASET_ID, RELEWISE_API_KEY, {
    serverUrl: RELEWISE_SERVER_URL,
  });
}

if (!customElements.get('relewise-product-recommendations') && recommender) {

  class RelewiseProductRecommendations extends HTMLElement {
    constructor() {
      super();
        // Find the parent element with the specified class
        let targetElement = this.parentElement;
        while (targetElement && !targetElement.classList.contains('section-relewise-recommendations')) {
            targetElement = targetElement.parentElement;
        }

        if (targetElement) {
            const observer = new IntersectionObserver((entries, observer) => {
                // Check if the target element is intersecting
                if (entries[0].isIntersecting) {
                    this.init(); // Call your initialization function

                    // Disconnect the observer once the component is visible and initialized
                    observer.disconnect();
                }
            });

            // Start observing the found parent element
            observer.observe(targetElement);
        } else {
            // Fallback or error handling: If no parent with the class is found,
            // you might want to initialize directly or log an error.
            console.warn('RelewiseProductRecommendations: Could not find a parent element with the class "section-relewise-recommendations". Initializing directly.');
            this.init();
        }
    }

    async init() {
      this.language = relewiseData.current_locale;
      this.currency = relewiseData.current_currency;
      this.displayedAt = relewiseData.current_template;

      this.resultAmount = this.getAttribute('data-recommendation-limit');
      this.recommendationType = this.getAttribute('data-recommendation-type');
      this.productId = this.getAttribute('data-product-id');
      this.variantId = this.getAttribute('data-variant-id');
      this.basedOn = this.getAttribute('data-based-on');
      this.gender = this.getAttribute('data-gender');
      this.user = await getUser();

      this.recommendations = await this.getRecommendations();

      this.swiperEl = this.querySelector('.swiper') || false;
      if (this.recommendations?.recommendations?.length > 0) await this.fillRecommendations();
    }

    async getRecommendations() {
      const settings = {
        language: this.language,
        currency: this.currency,
        displayedAtLocation: this.displayedAt,
        user: this.user
      };

      let results = [];

      if (this.recommendationType === 'popular') {
        let popularProductsBuilder = new PopularProductsBuilder(settings)
          .sinceMinutesAgo(20160)
          .setSelectedProductProperties({
            displayName: true,
            pricing: true,
            allData: true,
            allVariants: true,
            basedOn: this.basedOn
          })
          .setSelectedVariantProperties({
            displayName: true,
            pricing: true,
            allData: true,
          })
          .setNumberOfRecommendations(this.resultAmount);

        if (this.gender != '' && this.gender != 'unisex') {
          popularProductsBuilder = popularProductsBuilder.filters(f => f
            .addProductDataFilter(
              'intersport-dk.myshopify.com_custom.kon',
              (conditionBuilder) => conditionBuilder.addContainsCondition(this.gender)
            )
          );
        }

        results = await recommender.recommendPopularProducts(popularProductsBuilder.build());

      } else if (this.recommendationType === 'similar') {
        let similarProductsBuilder = new SimilarProductsProductBuilder(settings)
          .setSelectedProductProperties({
            displayName: true,
            pricing: true,
            allVariants: true,
            allData: true
          })
          .setSelectedVariantProperties({
            displayName: true,
            pricing: true,
            allData: true,
          })
          .product({ productId: this.productId, variantId: this.variantId })
          .setNumberOfRecommendations(this.resultAmount);

        if (this.gender != '' && this.gender != 'unisex') {
          similarProductsBuilder = similarProductsBuilder.filters(f => f
            .addProductDataFilter(
              'intersport-dk.myshopify.com_custom.kon',
              (conditionBuilder) => conditionBuilder.addContainsCondition(this.gender)
            )
          );
        }

        results = await recommender.recommendSimilarProducts(similarProductsBuilder.build());

      } else if (this.recommendationType === 'viewed_after') {
        let viewedAfterViewingbuilder = new ProductsViewedAfterViewingProductBuilder(settings)
          .setSelectedProductProperties({
            displayName: true,
            pricing: true,
            allVariants: true,
            allData: true
          })
          .setSelectedVariantProperties({
            displayName: true,
            pricing: true,
            allData: true,
          })
          .product({ productId: this.productId, variantId: this.variantId })
          .setNumberOfRecommendations(this.resultAmount);

        if (this.gender != '' && this.gender != 'unisex') {
          viewedAfterViewingbuilder = viewedAfterViewingbuilder.filters(f => f
            .addProductDataFilter(
              'intersport-dk.myshopify.com_custom.kon',
              (conditionBuilder) => conditionBuilder.addContainsCondition(this.gender)
            )
          );
        }

        results = await recommender.recommendProductsViewedAfterViewingProduct(viewedAfterViewingbuilder.build());

      } else if (this.recommendationType === 'recently_viewed') {
        const recentlyViewedProductsBuilder = new RecentlyViewedProductsBuilder(settings)
          .setSelectedProductProperties({
            displayName: true,
            pricing: true,
            allData: true
          })
          .setSelectedVariantProperties({
            displayName: true,
            pricing: true,
            allData: true,
          })
          .setNumberOfRecommendations(this.resultAmount);
        results = await recommender.recentlyViewedProducts(recentlyViewedProductsBuilder.build());
      }
      return results;
    }

    async fillRecommendations() {
      const placeToRenderProducts = this.querySelector('.swiper-wrapper.secondary-wrapper');
      await this.recommendations.recommendations.forEach((product) => {
        const swiperSlide = document.createElement('div');
        swiperSlide.classList.add('swiper-slide');
        const productCard = fillProduct(product);
        swiperSlide.appendChild(productCard);
        placeToRenderProducts.appendChild(swiperSlide);
      });
      this.classList.remove("hidden")
    }
  }

  customElements.define('relewise-product-recommendations', RelewiseProductRecommendations);
}

